<template>
  <!-- 210304 | id 추가 -->
  <section
    id="projects"
    class="projects"
  >
    <div class="projects__inner">
      <h2 class="title title--projects">
        UILab 의 경험들
        <img src="@/assets/images/img-experience.png">
      </h2>
      <ul class="projects__list">
        <li
          v-for="(work, i) in works"
          :key="`${work.title}_${i}`"
          class="projects__item"
        >
          <div class="projects__left">
            <span class="projects__date">{{ work.title }}</span>
          </div>
          <div class="projects__right">
            <p class="projects__text">
              <span
                v-for="(item, j) in work.list"
                :key="`${work.title}_${i}_${j}`"
              >
                <template v-if="j">/</template>
                {{ item.name }}
              </span>
            </p>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Works',
  data() {
    return {
      works: []
		} 
  },
  computed: {
	},
  watch: {},
  created() {
		this.getData()
	},
  mounted() {
	},
  methods: {
		getData() {
			axios.get(`${process.env.BASE_URL}data/works.json`)
				.then(response => {
					this.works = response.data
				})
				.catch(error => {
					this.$eventHub.$emit('showError', error)
				})
				.then(() => {
				})
		}
	}
}
</script>

<style lang="scss" scoped>
.projects{
  $self:&;
  width:100%;
  background-color: #f0f0f3;
  padding:41px 0 110px 0;
  &__inner{
    width:1000px;
    margin:0 auto;
  }
  &__list{
    width:100%;
  }
  &__item{
    width:100%;
    background-color: #fff;
    border-radius: 8px;
    padding:30px 24px 30px 30px;
    box-shadow: 4px 6px 24px 0 rgba(0, 0, 0, 0.08);
    &:not(:first-child){
      margin-top:10px;
    }
    &:after{
      clear:both;
      display:block;
      content:'';
    }
  }
  &__left{
    float:left;
    width:82px;
    height:70px;
  }
  &__date{
    font-size:30px;
    font-weight:bold;
    letter-spacing: -1.43px;
    line-height:1.47;
    color:#111111;
  }
  &__right{
    float:left;
    width:843px;
    margin-left:18px;  
  }
  &__text{
    font-size: 15px;
    line-height: 1.73;
    letter-spacing: -0.72px;
    color: #222222;
    font-weight: normal;
    line-height: 2.4;
    letter-spacing: 0;
    color: #222222;
    text-align:left;
  }
}
.title--projects {
  position:relative;
  overflow: hidden;
  img {
    position: absolute;
    right:0;
    bottom:-149px;
    width:219px;
    height:298px;
    animation: flicker 6s ease alternate infinite;
  }
}
@keyframes flicker {
  0% {
    transform: rotate(0)
  } 50% {
    transform: rotate(5deg);
  } 100% {
    transform: rotate(0);
  }
}
</style>